import React from "react";

import TextAreaWithButton from "./Common/TextAreaWithButton";

const AnalyticsAndReports = () => {
  const handleSave = text => logger.info(text);
  return (
    <TextAreaWithButton
      title="Used in Calculations and Reports"
      handleSave={handleSave}
    />
  );
};

export default AnalyticsAndReports;
